export const toCalendarButtonClicked = 'to_calendar_button_clicked';

export const toSelectEntrancesButtonClicked = 'to_select_entrances_button_clicked';

export const toPurchaseSummaryButtonClicked = 'to_purchase_summary_button_clicked';

export const toPaymentServiceButtonClicked = 'to_payment_service_button_clicked';

export const paymentStarted = 'payment_started';

export const canopyAdded = 'canopy_added';

export const canopyRemoved = 'canopy_removed';

export const grillAdded = 'grill_added';

export const grillRemoved = 'grill_removed';

// Value of the `flow` property, to tell the ticket purchase apart from the
// screens it shares events with (date changes and gift cards).
export const flows = {
  purchase: 'purchase',
  purchaseChange: 'purchaseChange',
  giftCard: 'giftCard',
} as const;
